// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldService_labelContainer__JLTCd"};